import { FC } from 'react';
import { Modal } from 'antd';

import { useModalsStore } from '../../modals.store';
import { InvalidTypeModalProps } from '../../types';

export const InvalidTypeModal: FC<InvalidTypeModalProps> = ({ modalType }) => {
  const modals = useModalsStore();

  return (
    <Modal
      title={`Invalid modal type`}
      open={true}
      onClose={modals.closeModal}
      onCancel={modals.closeModal}
      footer={null}
      width={300}
    >
      {modalType}
    </Modal>
  );
};
